import React from 'react';
import { FacilitiesHeader } from '../../components/facilitiesScreen/facility-header';
import _ from 'lodash';
export var FacilitiList = React.createClass({
    getInitialState() {
        return {
            listItem: this.props.list

        }
    },
    componentWillMount() {

    },
    generateList: function () {


        var list = this.props.data.map(function (listItem, key) {
            let admin_length = _.filter(listItem.users, function (i) {
                return i.roleId == 2 && i.status == "APPROVE" || i.status == "ACCEPTED";
            });
            let staff_length = _.filter(listItem.users, function (i) {
                return i.roleId != 2 && i.roleId != 7;
            });
            let patients_length = _.filter(listItem.users, function (i) {
                return i.roleId == 7;
            });
            let class_name = admin_length.length ? "" : "no_admins";
            return (<li className={class_name} key={key}>
                <div className="facility-item"><ul className="facility-item-holder">
                    <li className="name">
                        <div className="name-width" data-facilit-id={listItem.id} onClick={this.props.viewAction}>
                            <span data-facilit-id={listItem.id} className="icon icon-hospital"></span>{listItem.name}</div>
                    </li>
                    <li className="phone"><span className="icon icon-phone"></span>{listItem.mobile}</li>
                    <li className="email">
                        <div className="name-width"><span className="icon icon-email"></span>{listItem.email}</div>
                    </li>
                    <li className="admin-detail">
                        <div className="view-details text-center">
                            <ul>
                                <li className="admin">
                                    <p>ADMIN</p>
                                    <h4>{admin_length.length}</h4>
                                </li>
                                <li className="staff">
                                    <p>STAFF</p>
                                    <h4>{staff_length.length}</h4>
                                </li>
                                <li className="patients">
                                    <p>PATIENTS</p>
                                    <h4>{patients_length.length}</h4>
                                </li>
                            </ul>
                        </div>
                    </li>

                    <li className="add-admin">{admin_length.length ? <button className="white-button" data-facilit-id={listItem.id} onClick={this.props.viewAction}>view</button> : <button className="gray-button" data-facilit-id={listItem.id} onClick={this.props.add_dmin}>Add Admin</button>}</li>
                </ul>
                </div>
            </li>)
        }, this);
        if (list.length) {
            return list;
        } else {
            var style = {
                textAlign: 'center'
            }
            return <li style={style}>No Records found</li>;
        }

    },

    render() {
        return (
            <div>
                <div className="facility-list-grid">
                    <div className={this.props.toggleClass} id="grid">
                        <ul>
                            <li className="list-head">
                                <ul className="facility-item-holder">
                                    <li className="name">Clinic Name</li>
                                    <li className="phone">Phone</li>
                                    <li className="email">Email</li>
                                    <li className="admin">Admin</li>
                                    <li className="staff">Staff</li>
                                    <li className="patients">Patients</li>
                                    <li></li>
                                </ul>
                            </li>
                            {this.generateList()}
                        </ul>
                    </div>
                </div></div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/staff/staffFacilitieslist.js
 **/